export const TRANSLATIONS_EN_ONBOARDING = {
  "homePublic.hero.eyebrow": "Live product view",
  "homePublic.hero.title": "Your account-grade workspace, before connecting anything",
  "homePublic.hero.subtitle":
    "Explore a mock environment populated with anonymized metrics so you can see how Innovadoc IA keeps teams aligned before going live.",
  "homePublic.hero.ctaPrimary": "Create my account",
  "homePublic.hero.ctaSecondary": "Access existing workspace",
  "homePublic.hero.metrics.documents": "Documents indexed",
  "homePublic.hero.metrics.latency": "Median response time",
  "homePublic.hero.metrics.compliance": "Knowledge coverage",
  "homePublic.mock.eyebrow": "Mock telemetry",
  "homePublic.mock.title": "Signals generated with safe data",
  "homePublic.mock.subtitle":
    "These numbers refresh automatically to illustrate how the platform feels with active traffic.",
  "homePublic.mock.cards.documents.label": "Documents this week",
  "homePublic.mock.cards.documents.detail": "Unique uploads synced in the last 7 days",
  "homePublic.mock.cards.repositories.label": "Connected sources",
  "homePublic.mock.cards.repositories.detail": "Drive, SharePoint, S3, Gmail and more",
  "homePublic.mock.cards.users.label": "Active seats",
  "homePublic.mock.cards.users.detail": "Members interacting with chat + automations",
  "homePublic.mock.cards.alerts.label": "Attention alerts",
  "homePublic.mock.cards.alerts.detail": "Pending remediation items for admins",
  "homePublic.features.eyebrow": "What you get",
  "homePublic.features.title": "Enterprise readiness from day zero",
  "homePublic.features.subtitle": "Everything you need to try the experience without touching production data.",
  "homePublic.features.ingestion.title": "Frictionless ingestion",
  "homePublic.features.ingestion.desc": "Drop folders, forward emails or connect repositories in minutes.",
  "homePublic.features.security.title": "Security first",
  "homePublic.features.security.desc": "SOC 2 aligned controls, granular permissions and workspace isolation.",
  "homePublic.features.operations.title": "Operations aware",
  "homePublic.features.operations.desc": "Live dashboards, health alerts and task queues for human-in-the-loop.",
  "homePublic.plan.eyebrow": "Plan snapshot",
  "homePublic.plan.title": "Starter plan with real safeguards",
  "homePublic.plan.subtitle": "Designed for innovation leaders validating RAG experiences with internal stakeholders.",
  "homePublic.plan.points.speed.title": "Faster pilots",
  "homePublic.plan.points.speed.desc": "Provision dedicated vector stores and ready-to-use chat flows.",
  "homePublic.plan.points.context.title": "Context you can trust",
  "homePublic.plan.points.context.desc": "Auto-detect PII, classify repositories and keep lineage on every chunk.",
  "homePublic.plan.points.support.title": "Guided rollout",
  "homePublic.plan.points.support.desc": "Partner success team plus async office hours to keep momentum.",
  "homePublic.plan.card.title": "What is included",
  "homePublic.plan.card.subtitle": "10 users · 2 workspaces · 50K prompt credits · premium telemetry.",
  "homePublic.plan.card.ctaPrimary": "Start free pilot",
  "homePublic.plan.card.ctaSecondary": "See enterprise options",
  "homePublic.testimonial.quote": "The mock environment helped our compliance team approve the rollout in a single week.",
  "homePublic.testimonial.author": "Lucía Hernández",
  "homePublic.testimonial.role": "AI Transformation Lead, Vectoris",
  "homePublic.cta.title": "Ready to see your documents light up?",
  "homePublic.cta.subtitle": "Spin up Innovadoc IA with mock data today and plug your repositories whenever legal gives the green light.",
  "homePublic.cta.primary": "Launch workspace",
  "homePublic.cta.secondary": "Talk to an expert",
  "wizard.welcome_title": "Welcome to the wizard!",
  "wizard.welcome_image_alt": "Welcome illustration",
  "wizard.welcome_description":
    "Set up your profile and preferences to start using the system.",
  "wizard.profile_title": "Profile Information",
  "wizard.profile_description": "Tell us about yourself and your organization.",
  "wizard.preferences_title": "Preferences",
  "wizard.preferences_description":
    "Customize your experience by selecting theme, language, and other options.",
  "wizard.complete_title": "All set!",
  "wizard.complete_description":
    "Your profile has been successfully configured.",
  "wizard.feature_chat_title": "Smart Chat",
  "wizard.feature_chat_desc":
    "Ask questions and get accurate answers based on your documents.",
  "wizard.feature_docs_title": "Document Management",
  "wizard.feature_docs_desc":
    "Upload, organize, and query your documents easily.",
  "wizard.feature_insights_title": "Analytics and Insights",
  "wizard.feature_insights_desc":
    "Get relevant analysis and statistics from your data.",
  "wizard.first_name": "First Name",
  "wizard.first_name_required": "First name is required.",
  "wizard.lastname": "Last Name",
  "wizard.lastname_required": "Last name is required.",
  "wizard.role": "Role",
  "wizard.role_required": "Role is required.",
  "wizard.country": "Country",
  "wizard.country_required": "Country is required.",
  "wizard.company": "Company",
  "wizard.company_required": "Company is required.",
  "wizard.timezone": "Time Zone",
  "wizard.timezone_select": "Select your time zone",
  "wizard.timezone_required": "Time zone is required.",
  "wizard.timezone_search": "Search city or zone...",
  "wizard.timezone_no_results": "No results",
  "wizard.org_type": "Organization Type",
  "wizard.org_enterprise": "Enterprise",
  "wizard.org_education": "Education",
  "wizard.org_government": "Government",
  "wizard.org_nonprofit": "Nonprofit",
  "wizard.org_other": "Other",
  "wizard.org_size": "Organization Size",
  "wizard.size_small": "Small (1-50)",
  "wizard.size_medium": "Medium (51-250)",
  "wizard.size_large": "Large (251-1000)",
  "wizard.size_enterprise": "Enterprise (1000+)",
  "wizard.theme_preference": "Theme Preference",
  "wizard.language_preference": "Language Preference",
  "wizard.yes": "Yes",
  "wizard.no": "No",
  "wizard.other_preferences": "Other Preferences",
  "wizard.enable_notifications": "Enable notifications",
  "wizard.allow_data_collection": "Allow anonymous data collection",
  "wizard.data_collection_info":  "Your data helps improve the system. No personal information is collected.",
  "wizard.summary_title": "Configuration Summary",
  "wizard.previous": "Previous",
  "wizard.next": "Next",
  "wizard.complete": "Complete",
  "wizard.save_error": "Error saving configuration. Please try again.",
  "wizard.copy_support_reference": "Copy code",
  "wizard.support_reference_copied": "Copied",
  "wizard.second_name": "Last Name",
  "wizard.second_name_required": "Last Name is required.",
  "wizard.job_title": "Job Title",
  "wizard.job_required": "Job Title is required.",
  filtered_results: "filtered results",
  "invite.validating": "Validating invitation...",
  "invite.invalid_or_expired": "Invalid or expired invitation",
  "invite.invalid_or_expired_desc": "The invitation link is no longer valid. Ask your administrator for a new invitation.",
  "invite.missing_params": "Incomplete invitation",
  "invite.missing_params_desc": "The invitation link does not include the required information to continue.",
  "invite.not_found": "Invitation not found",
  "invite.not_found_desc": "We could not find an active invitation for this email.",
  "invite.server_error": "We could not validate the invitation",
  "invite.server_error_desc": "An error occurred while validating the invitation. Try again later.",
  "invite.bad_request": "The submitted information is not valid.",
  "invite.back_to_login": "Back to login",
  "invite.email": "Invited email",
  "invite.company": "Company",
  "invite.role": "Role",
  "invite.company_from_invite": "The company is defined by the invitation.",
  "invite.password_step": "Create your password",
  "invite.password_step_desc": "Set a secure password to complete your access.",
  "invite.password": "Password",
  "invite.password_placeholder": "Enter your password",
  "invite.password_required": "Password is required.",
  "invite.password_min_length": "Password must be at least 8 characters.",
  "invite.password_hint": "Use at least 8 characters.",
  "invite.confirm_password": "Confirm password",
  "invite.confirm_password_placeholder": "Repeat your password",
  "invite.passwords_not_match": "Passwords do not match.",
};
